import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const fundTableTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'FUND_TABLE');
export const explixitContractFundTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'EXPLIXIT_CONTRACT_FUNDS');


export const requestFundTable = () => {
    return {
        type: fundTableTypes.REQUEST,
    };
};

export const receiveFundTable = (response) => {
    return {
        type: fundTableTypes.RECEIVE,
        data: response,
    };
};

export const receiveFundTableError = (response) => {
    return {
        type: fundTableTypes.ERROR,
        error: response,
    };
};

export const getFundTable = () => {
    return dispatch => {

        let apiUrl = `/api/v1/customer/getfundtable`

        dispatch(requestFundTable());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveFundTable(response));
            } catch (e) {
                dispatch(receiveFundTableError(response));
            }
        })
        .catch(handleNetworkError);
    };
};

export const requestExplicitContractFunds = () => {
    return {
        type: explixitContractFundTypes.REQUEST,
    };
};

export const receiveExplicitContractFunds = (response) => {
    return {
        type: explixitContractFundTypes.RECEIVE,
        data: response,
    };
};

export const receiveExplicitContractFundsError = (response) => {
    return {
        type: explixitContractFundTypes.ERROR,
        error: response,
    };
};


export const getExplicitContractFunds = () => {
    return dispatch => {

        let apiUrl = `/api/v1/customer/getexplixitcontractfunds`

        dispatch(requestExplicitContractFunds());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveExplicitContractFunds(response));
            } catch (e) {
                dispatch(receiveExplicitContractFundsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};